export default function getTranslatedLabel(translations, i18nKey, defaultText) {
    if (i18nKey) {
        const translatedText = translations[i18nKey];
        if (!translatedText) {
            return defaultText !== null && defaultText !== void 0 ? defaultText : '';
        }
        return translatedText;
    }
    return defaultText !== null && defaultText !== void 0 ? defaultText : '';
}
